import { useQuery } from '@tanstack/react-query'
import { jsonFetch } from '@/lib/api/jsonFetch'
import type { GroupBy, MarginQuery, MarginReportResponse } from './types'

/** Maps each grouping dimension to the backend substring-match filter
 *  param that searches it before aggregation (margin_report.py:1021-1037).
 *  `month` has no matching filter — buckets are always few, so search
 *  stays client-side for that dimension. */
const SEARCH_PARAM_BY_GROUP: Record<GroupBy, string | null> = {
  product: 'product_name',
  customer: 'customer_name',
  vendor: 'vendor_name',
  salesperson: 'salesperson',
  month: null,
}

export function useMargins(q: MarginQuery) {
  return useQuery({
    queryKey: ['margins', 'report', q],
    queryFn: () => {
      const params = new URLSearchParams({
        group_by: q.group_by,
        date_from: q.date_from,
        date_to: q.date_to,
      })
      if (q.limit != null) params.set('limit', String(q.limit))
      if (q.offset != null) params.set('offset', String(q.offset))
      const searchParam = SEARCH_PARAM_BY_GROUP[q.group_by]
      if (searchParam && q.search?.trim()) {
        params.set(searchParam, q.search.trim())
      }
      return jsonFetch<MarginReportResponse>(
        `/api/margin/report?${params.toString()}`,
      )
    },
    staleTime: 60_000,
  })
}
